const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
    ? {loggedIn: true, user, singleHands: {}, selectedHand: null}
    : {qrCode: null, qrCheckStatus: null}

export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    LOGIN_SHOW: 'LOGIN_SHOW',
    LOGIN_HIDE: 'LOGIN_HIDE',
    LOGOUT: 'USERS_LOGOUT',
}

export const qrCodeLogin = {
    QR_GENERATE_SUCCESS: 'QR_GENERATE_SUCCESS',
    QR_CHECK: 'QR_CHECK',
}

export const trainerConstants = {
    TRAINER_START: 'TRAINER_START',
    TRAINER_ACTION: 'TRAINER_ACTION',
    TRAINER_RESULT: 'TRAINER_RESULT',
    TRAINER_LOADING: 'TRAINER_LOADING',
}

export const handConstants = {
    HAND_RAW_REQUEST: 'HAND_RAW_REQUEST',
    HAND_RAW_SUCCESS: 'HAND_RAW_SUCCESS',

    HAND_RAW_LIMIT_REQUEST: 'HAND_RAW_LIMIT_REQUEST',
    HAND_RAW_LIMIT_SUCCESS: 'HAND_RAW_LIMIT_SUCCESS',

    HAND_RAW_SHOW: 'HAND_RAW_SHOW',
    HAND_RAW_HIDE: 'HAND_RAW_HIDE',

    HAND_LIST_REQUEST: 'HAND_LIST_REQUEST',
    HAND_LIST_SUCCESS: 'HAND_LIST_SUCCESS',

    /******Hand line stats *******/
    HAND_LINES_STATS_REQUEST: 'HAND_LINES_STATS_IS_REQUEST',
    HAND_LINES_STATS_IS_LOADING: 'HAND_LINES_STATS_IS_LOADING',
    HAND_LINES_STATS_ERROR: 'HAND_LINES_STATS_ERROR',
    HAND_LINES_STATS_SUCCESS: 'HAND_LINES_STATS_SUCCESS',

    /******Hand line stats for players*******/
    HAND_LINES_STATS_FOR_PLAYERS_REQUEST: 'HAND_LINES_STATS_FOR_PLAYERS_REQUEST',
    HAND_LINES_STATS_FOR_PLAYERS_SUCCESS: 'HAND_LINES_STATS_FOR_PLAYERS_SUCCESS',

    /******Hand Mistake Stats *******/
    HAND_MISTAKE_STATS_REQUEST: 'HAND_MISTAKE_STATS_REQUEST',
    HAND_MISTAKE_STATS_SUCCESS: 'HAND_MISTAKE_STATS_SUCCESS',

    HAND_SINGLE_REQUEST: 'HAND_SINGLE_REQUEST',
    HAND_SINGLE_SUCCESS: 'HAND_SINGLE_SUCCESS',

    HAND_REPORT_REQUEST: 'HAND_REPORT_REQUEST',
    HAND_REPORT_SUCCESS: 'HAND_REPORT_SUCCESS',

    HAND_LINE_IS_LOADING: 'HAND_LINE_IS_LOADING',
    HAND_LINE_SUCCESS: 'HAND_LINE_SUCCESS',

    SET_SELECTED_ROW_ID: 'SET_SELECTED_ROW_ID',

    SET_HAND_STACKS: 'SET_HAND_STACKS',
    SET_HAND_STACKS_PARSE: 'SET_HAND_STACKS_PARSE',

    SELECT_HAND: 'SELECT_HAND',
}

export const uploadConstants = {
    UPLOAD_TASK_LOADING: 'UPLOAD_TASK_LOADING',
    UPLOAD_TASK_LOAD_COMPLETE: 'UPLOAD_TASK_LOAD_COMPLETE',
    UPLOAD_TASK_REQUEST: 'UPLOAD_TASK_REQUEST',
    UPLOAD_TASK_SUCCESS: 'UPLOAD_TASK_SUCCESS',
    UPLOAD_REQUEST: 'UPLOAD_REQUEST',
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
    NEW_UPLOAD: 'NEW_UPLOAD',
    UPLOAD_FAILURE: 'UPLOAD_FAILURE',
}

export const librariesConstants = {
    LIBRARIES_REQUEST: 'LIBRARIES_REQUEST',
    LIBRARIES_SUCCESS: 'LIBRARIES_SUCCESS',
    LIBRARIES_FAILURE: 'LIBRARIES_FAILURE',
}

export const licensesConstants = {
    LICENSES_REQUEST: 'LICENSES_REQUEST',
    LICENSES_SUCCESS: 'LICENSES_SUCCESS',
    LICENSES_FAILURE: 'LICENSES_FAILURE',
}

export const prorateConstants = {
    PRORATE_REQUEST: 'PRORATE_REQUEST',
    PRORATE_SUCCESS: 'PRORATE_SUCCESS',
    PRORATE_CLEAR: 'PRORATE_CLEAR'
}

export const keyConstants = {
    APPLY_KEY_REQUEST: 'APPLY_KEY_REQUEST',
    APPLY_KEY_SUCCESS: 'APPLY_KEY_SUCCESS',
    APPLY_KEY_FAILURE: 'APPLY_KEY_FAILURE',
    APPLY_KEY_SHOW: 'APPLY_KEY_SHOW',
    APPLY_KEY_HIDE: 'APPLY_KEY_HIDE',
}

export const preferencesConstant = {
    PREFERENCES_REQUEST: 'PREFERENCES_REQUEST',
    PREFERENCES_SUCCESS: 'PREFERENCES_SUCCESS',
    PREFERANCES_FAILURE: 'PREFERANCES_FAILURE',
    PREFERENCES_UPDATE_REQUEST: 'PREFERENCES_UPDATE_REQUEST',
    PREFERENCES_UPDATE_SUCCESS: 'PREFERENCES_UPDATE_SUCCESS',
}

// authenticate reducer
export function auth_reducer(state = initialState, action) {
    switch (action.type) {
        case userConstants.LOGIN_SHOW:
            return {
                ...state,
                loginOpened: true,
            }

        case userConstants.LOGIN_HIDE:
            return {
                ...state,
                loginOpened: false,
            }

        case userConstants.LOGIN_REQUEST:
            return {
                ...state,
                loggingIn: true,
                user: action.user,
            }

        case userConstants.LOGIN_SUCCESS:
            return {
                ...state,
                loggedIn: true,
                user: action.user,
            }

        case userConstants.LOGIN_FAILURE:
            return {
                ...state,
                errorText: action.error,
                loggingIn: false,
            }

        case userConstants.LOGOUT:
            return {}

        case qrCodeLogin.QR_GENERATE_SUCCESS: {
            return {
                ...state,
                qrCode: action.code,
            }
        }
        case qrCodeLogin.QR_CHECK: {
            return {
                ...state,
                qrCheckStatus: action.result,
            }
        }
        default:
            return state
    }
}

// libraries reducer
export function libraries_reducer(state = initialState, action) {
    switch (action.type) {
        case librariesConstants.LIBRARIES_REQUEST:
            return {
                ...state,
                librariesRequest: true,
            }
        case librariesConstants.LIBRARIES_SUCCESS:
            return {
                ...state,
                librariesRequest: false,
                librariesResponse: action.librariesResponse,
            }
        default:
            return state
    }
}

// licenses reducer
export function licenses_reducer(state = initialState, action) {
    switch (action.type) {
        case licensesConstants.LICENSES_REQUEST:
            return {
                ...state,
                licensesRequest: true,
            }
        case licensesConstants.LICENSES_SUCCESS:
            return {
                ...state,
                licensesRequest: false,
                licensesResponse: action.licensesResponse,
            }
        default:
            return state
    }
}

export function prorate_reducer(state = initialState, action) {
    switch (action.type) {
        case prorateConstants.PRORATE_REQUEST:
            return {
                ...state,
                prorateRequest: true,
                prorateResponse: null,

            }
        case prorateConstants.PRORATE_SUCCESS:
            return {
                ...state,
                prorateRequest: false,
                prorateResponse: action.data.data,
            }
        case prorateConstants.PRORATE_CLEAR:
            return {
                ...state,
                prorateRequest: false,
                prorateResponse: null,
            }
        default:
            return state
    }
}

// apply key reduce
export function apply_key_reducer(state = initialState, action) {
    switch (action.type) {
        case keyConstants.APPLY_KEY_REQUEST:
            return {
                ...state,
                applyKeyRequest: true,
            }
        case keyConstants.APPLY_KEY_SUCCESS:
            return {
                ...state,
                applyKeyRequest: false,
                applyKeyResponse: action.applyKeyResponse,
            }
        case keyConstants.APPLY_KEY_SHOW:
            return {
                ...state,
                applyKeyVisible: true,
                applyKeyResponse: null,
            }
        case keyConstants.APPLY_KEY_HIDE:
            return {
                ...state,
                applyKeyVisible: false,
                applyKeyResponse: null,
            }
        default:
            return state
    }
}

// apply key reduce
export function preferences_reducer(state = initialState, action) {
    switch (action.type) {
        case preferencesConstant.PREFERENCES_REQUEST:
            return {
                ...state,
                preferencesRequest: true,
            }
        case preferencesConstant.PREFERENCES_SUCCESS:
            return {
                ...state,
                preferencesRequest: false,
                preferencesUpdateRequest: false,
                preferencesResponse: action.preferencesResponse,
            }
        case preferencesConstant.PREFERENCES_UPDATE_REQUEST:
            return {
                ...state,
                preferencesUpdateRequest: true,
            }

        default:
            return state
    }
}

// reducer for hands
export function hand_reducer(state = initialState, action) {
    switch (action.type) {
        case handConstants.HAND_RAW_REQUEST:
            return {
                ...state,
                rawHandRequest: true,
            }

        case handConstants.SET_SELECTED_ROW_ID:
            return {
                ...state,
                selectedRowIndex: action.payload,
            }

        case handConstants.HAND_RAW_SUCCESS:
            return {
                ...state,
                rawHandRequest: false,
                rawHandResponse: action.rawHandResponse,
            }

        case handConstants.HAND_RAW_LIMIT_REQUEST:
            return {
                ...state,
                rawHandLimitRequest: true,
            }

        case handConstants.HAND_RAW_LIMIT_SUCCESS:
            return {
                ...state,
                rawHandLimitRequest: false,
                rawHandLimitResponse: action.rawHandLimitResponse,
            }

        case handConstants.HAND_RAW_SHOW:
            return {
                ...state,
                rawHandVisible: true,
            }
        case handConstants.HAND_RAW_HIDE:
            return {
                ...state,
                rawHandVisible: false,
            }

        case handConstants.SET_HAND_STACKS: {
            const {minStack, maxStack} = action

            return {
                ...state,
                minStack,
                maxStack,
            }
        }

        case handConstants.SET_HAND_STACKS_PARSE: {
            const {minStack, maxStack} = action

            return {
                ...state,
                minStack,
                maxStack,
            }
        }

        case handConstants.HAND_SINGLE_REQUEST:
            return {
                ...state,
                singleHandRequest: true,
            }

        case handConstants.SELECT_HAND:
            return {
                ...state,
                selectedHand: action.handId,
            }

        case handConstants.HAND_SINGLE_SUCCESS: {
            return {
                ...state,
                singleHandRequest: false,
                singleHandResponse: action.singleHandResponse,
                selectedHand: action.handId,
                singleHands: {
                    ...state.singleHands,
                    [action.handId]: {
                        ...action.singleHandResponse,
                    },
                },
            }
        }

        case handConstants.HAND_LIST_REQUEST:
            return {
                ...state,
                listHandRequest: true,
                singleHandResponse: null
            }
        case handConstants.HAND_LIST_SUCCESS:
            return {
                ...state,
                listHandRequest: false,
                listHandResponse: action.listHandResponse,
            }

        /***********HAND_LINES_STATS*************/

        case handConstants.HAND_LINES_STATS_REQUEST:
            return {
                ...state,
                listHandLinesStatsRequest: true,
            }
        case handConstants.HAND_LINES_STATS_SUCCESS:
            return {
                ...state,
                listHandLinesStatsRequest: false,
                listHandLinesStatsResponse: action.listHandLinesStatsResponse,
            }

        /***********HAND_LINES_STATS_FOR_PLAYERS*************/
        case handConstants.HAND_LINES_STATS_FOR_PLAYERS_REQUEST:
            return {
                ...state,
                listHandLinesStatsForPlayersRequest: true,
            }
        case handConstants.HAND_LINES_STATS_FOR_PLAYERS_SUCCESS:
            return {
                ...state,
                listHandLinesStatsForPlayersRequest: false,
                listHandLinesStatsForPlayersResponse: action.listHandLinesStatsForPlayersResponse,
            }

        /***********HAND_MISTAKE_STATS*************/
        case handConstants.HAND_MISTAKE_STATS_REQUEST:
            return {
                ...state,
                listHandMistakeStatsRequest: true,
            }
        case handConstants.HAND_MISTAKE_STATS_SUCCESS:
            return {
                ...state,
                listHandMistakeStatsRequest: false,
                listHandMistakeStatsResponse: action.listHandMistakeStatsResponse,
            }

        case handConstants.HAND_REPORT_REQUEST:
            return {
                ...state,
                handReportRequest: true,
                handReportResponse: null,
            }

        case handConstants.HAND_REPORT_SUCCESS:
            return {
                ...state,
                handReportRequest: false,
                handReportResponse: action.handReportResponse,
            }

        /* Hand lines*/
        case handConstants.HAND_LINE_IS_LOADING:
            return {
                ...state,
                handLineIsLoading: action.payload,
            }
        case handConstants.HAND_LINE_SUCCESS:
            return {
                ...state,
                handLineResponse: action.payload,
            }

        default:
            return state
    }
}

// reducer for upload screen
export function upload_reducer(state = initialState, action) {
    switch (action.type) {
        case uploadConstants.UPLOAD_TASK_REQUEST:
            return {
                ...state,
                isTaskRequest: true,
            }

        case uploadConstants.UPLOAD_TASK_LOADING:
            return {
                ...state,
                uploadCompleted: false,
                parseCompleted: false,
                uploadProgress: action.uploadProgress,
            }

        case uploadConstants.UPLOAD_TASK_LOAD_COMPLETE:
            return {
                ...state,
                uploadCompleted: true,
                parseCompleted: false,
            }

        case uploadConstants.UPLOAD_TASK_SUCCESS:
            return {
                ...state,
                isTaskRequest: false,
                taskList: action.response,
            }

        case uploadConstants.UPLOAD_REQUEST:
            return {
                ...state,
                xhr: action.xhr,
                uploadCompleted: false,
                isUploadRequest: true,
                uploadFileRequestState: action.state,
            }

        case uploadConstants.UPLOAD_SUCCESS:
            return {
                ...state,
                isUploadRequest: false,
                uploadCompleted: false,
                parseCompleted: true,
                uploadResponse: action.response,
                uploadFileRequestState: {...state.uploadFileRequestState, done: true},
            }

        case uploadConstants.NEW_UPLOAD:
            typeof (state.xhr && state.xhr.abort) === 'function' && state.xhr.abort()

            return {
                ...state,
                xhr: null,
                isUploadRequest: false,
                uploadCompleted: false,
                parseCompleted: false,
                uploadResponse: null,
                uploadFileRequestState: null,
            }
        default:
            return state
    }
}
